import { LOCALE_COOKIE, LOCALE_COOKIE_MAX_AGE, isLocale, type Locale } from './config'

/** Reads the locale cookie in the browser. Returns null on the server. */
export function readLocaleCookie(): Locale | null {
  if(typeof document === 'undefined') return null
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${LOCALE_COOKIE}=([^;]*)`))
  if(!match) return null
  const value = decodeURIComponent(match[1])
  return isLocale(value) ? value : null
}

/**
 * Writes the locale cookie from the browser.
 *
 * Scoped to the current host rather than to a shared parent domain. fuse.mn,
 * fuse.page and fuse.contact are separate registrable domains and cannot share
 * a cookie anyway, and keeping it host-scoped means a user's choice on
 * fuse.page does not silently follow them onto every fuse.mn profile page.
 *
 * `SameSite=Lax` so it survives following a shared profile link. Not `Secure`
 * unconditionally, or it would never be set on localhost.
 */
export function writeLocaleCookie(locale: Locale) {
  if(typeof document === 'undefined') return
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${LOCALE_COOKIE}=${locale}; Path=/; Max-Age=${LOCALE_COOKIE_MAX_AGE}; SameSite=Lax${secure}`
}
